import DeliveryInstructionDeliveryCard from '@/models/DeliveryInstructionDeliveryCard/DeliveryInstructionDeliveryCard';

export default class DeliveryInstructionDeliveryCardFilter {

	constructor() {
	/*APP_FILTER_DEFINITION*/
		this.id = '';
		this.deliveryCardNumber = '';
		this.partId  = '';
		this.partPartNumber = '';
		this.dcQty = '';
		this.deliveryInstructionDetailId  = '';
		this.deliveryInstructionDetailPart = '';
		this.deliveryDateFrom = '';
		this.deliveryDateTo = '';
		this.sequence = '';
		this.totalDeliveryCard = '';
		this.isFullfiled = false;
		this.controlCardStatusId  = '';
		this.controlCardStatusName = '';
		this.isLoading = false;
		this.deliveryQty = '';
		this.isFromUpload = false;
		this.isSavedToBackend = false;
		this.draftFromUpload = '';
		this.draftMode = '';
	/*END_APP_FILTER_DEFINITION*/
		this.exactType = {
	/*APP_APP_FILTER_CRITERIA*/
			id : '0',
			deliveryCardNumber : '0',
			partId : '0',
			partPartNumber : '0',
			dcQty : '0',
			deliveryInstructionDetailId : '0',
			deliveryInstructionDetailPart : '0',
			deliveryDateFrom : '0',
			deliveryDateTo : '0',
			sequence : '0',
			totalDeliveryCard : '0',
			isFullfiled : '0',
			controlCardStatusId : '0',
			controlCardStatusName : '0',
			isLoading : '0',
			deliveryQty : '0',
			isFromUpload : '0',
			isSavedToBackend : '0',
	/*END_APP_FILTER_CRITERIA*/
		};
	}

}